export default __webpack_public_path__ + "static/media/IMG18.b510dfe3.jpeg";